export default "__VITE_ASSET__CyJh7GuA__"